/**
 * Base path for static assets when the app is hosted under a subpath (e.g. sr-demo at /app).
 * CRA sets PUBLIC_URL; sr-demo also sets REACT_APP_BASENAME for React Router.
 */
export function getPublicUrl(): string {
  return (process.env.REACT_APP_BASENAME || process.env.PUBLIC_URL || '').replace(/\/$/, '');
}

/** Prefix a site-root path with the public URL base (e.g. `/fonts/x.woff2` → `/app/fonts/x.woff2`). */
export function publicAssetPath(path: string): string {
  const base = getPublicUrl();
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalizedPath}`;
}

/** Basename for React Router; undefined when the app is served from domain root. */
export function getRouterBasename(): string | undefined {
  const base = getPublicUrl();
  return base || undefined;
}
